<script setup lang="ts">
</script>

<template>
  <NuxtLayout>
    <!-- <NuxtPwaManifest /> -->
    <NuxtPage />
  </NuxtLayout>
</template>
